// TR cart auto-update (clean + reliable)
// - Works with Dawn-like quantity markup: .quantity__button[name=plus/minus] + .quantity__input[data-index]
// - Updates Shopify cart via /cart/change.js so quantities persist after reload.

(() => {
  // Only run on cart page
  if (!document.body.classList.contains('template-cart')) return;

  const SELECTOR_INPUT = 'input.quantity__input[type="number"]';
  const SELECTOR_BTN = 'button.quantity__button[name="plus"], button.quantity__button[name="minus"]';

  let busy = false;

  const postChange = async ({ line, quantity }) => {
    const res = await fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ line, quantity })
    });
    if (!res.ok) throw new Error(`cart/change.js failed (${res.status})`);
    return res.json();
  };

  const getLineFromInput = (input) => {
    const v = parseInt(input?.dataset?.index || '', 10);
    if (Number.isFinite(v) && v > 0) return v;

    // fallback: try closest wrapper with data-index
    const row = input?.closest('[data-index]');
    const w = parseInt(row?.dataset?.index || '', 10);
    if (Number.isFinite(w) && w > 0) return w;

    return null;
  };

  const clampQty = (n) => {
    if (!Number.isFinite(n)) return 0;
    return Math.max(0, Math.floor(n));
  };

  const setDisabled = (root, disabled) => {
    root.querySelectorAll(SELECTOR_BTN).forEach((b) => (b.disabled = disabled));
    root.querySelectorAll(SELECTOR_INPUT).forEach((i) => (i.disabled = disabled));
  };

  // Click + / -
  document.addEventListener('click', async (e) => {
    const btn = e.target.closest(SELECTOR_BTN);
    if (!btn) return;

    const wrap = btn.closest('.quantity');
    const input = wrap?.querySelector(SELECTOR_INPUT);
    if (!input) return;

    const line = getLineFromInput(input);
    if (!line) return;

    // Let theme update the visible value first (some themes do this on click)
    requestAnimationFrame(async () => {
      if (busy) return;
      busy = true;

      try {
        // Read current (possibly already updated) value
        const current = clampQty(parseInt(input.value, 10));
        // If theme does NOT change value, compute ourselves:
        const isPlus = btn.getAttribute('name') === 'plus';
        const next = clampQty(isPlus ? current + 1 : current - 1);

        // If the theme already changed the value (e.g. from 11 -> 12),
        // next should match input.value; if not, we still send "next".
        setDisabled(wrap, true);
        await postChange({ line, quantity: next });

        // simplest + consistent with your setup:
        window.location.reload();
      } catch (err) {
        console.warn('TR cart auto-update error:', err);
        setDisabled(wrap, false);
        busy = false;
      }
    });
  }, true);

  // Typing in the number field (debounced)
  let t;
  document.addEventListener('input', (e) => {
    const input = e.target.closest(SELECTOR_INPUT);
    if (!input) return;

    const line = getLineFromInput(input);
    if (!line) return;

    clearTimeout(t);
    t = setTimeout(async () => {
      if (busy) return;
      busy = true;

      const qty = clampQty(parseInt(input.value, 10));

      try {
        const wrap = input.closest('.quantity') || document;
        setDisabled(wrap, true);
        await postChange({ line, quantity: qty });
        window.location.reload();
      } catch (err) {
        console.warn('TR cart auto-update error:', err);
        busy = false;
      }
    }, 350);
  }, true);
})();
